export default "__VITE_ASSET__B$jIfJIH__"